import Vue from "vue";
import DatePicker from "vue2-datepicker";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";
import moment from "moment";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { TH_SARABUN_TTF_BASE64 } from "@/assets/fonts/thsarabun.js";
import * as XLSX from "xlsx";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});

export default {
  components: {
    DatePicker,
    Paginate,
  },
  data: function () {
    return {
      busy: false,
      date_start: null,
      date_end: null,
      perPage: 6,
      sortBy: "name",
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      totalItem: 0,
      apiStatus: "กรุณาระบุวันที่และกดปุ่มแสดงข้อมูลเพื่อค้นหาข้อมูล",
      fields: [
        {
          key: "index",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "document_no",
          label: "เลขที่เอกสาร",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "bill_customer_name",
          label: "รายละเอียด",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "total_price",
          label: "ยอดขาย ฿",
          sortable: true,
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "font-weight-bold text-black td-top text-xs-1/2",
          class: "text-right",
        },
        {
          key: "cumulative_total",
          label: "ยอดขายรวม ฿",
          sortable: true,
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-black td-top text-xs-1/2",
          class: "text-right",
        },
      ],
      fields2: [
        {
          key: "index",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
        },
        {
          key: "email",
          label: "รหัสพนักงานขาย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
        },
        {
          key: "bill_seller_name",
          label: "ชื่อพนักงานขาย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
        },
        { key: "customers", label: "ลูกค้า" },
        // months 1..12
        // ...Array.from({ length: 12 }, (_, i) => ({
        //   key: `month_${i+1}`,
        //   label: ['ม.ค','ก.พ','มี.ค','เม.ย','พ.ค','มิ.ย','ก.ค','ส.ค','ก.ย','ต.ค','พ.ย','ธ.ค'][i],
        //   class: 'text-right'
        // })),
        // { key: 'year_total', label: 'ยอดรวมปี', class: 'text-right', sortable: true }
      ],
      fieldsCustomer: [
        {
          key: "index",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
        },
        {
          key: "customer_name",
          label: "ชื่อลูกค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          //   tdAttr: {
          //   style: `
          //     max-width: 200px;
          //     white-space: nowrap;
          //     overflow: hidden;
          //     text-overflow: ellipsis;
          //   `
          // }
        },
        // month_1…month_12 + year_total…
        ...Array.from({ length: 12 }, (_, i) => ({
          key: `month_${i + 1}`,
          label: new Date(0, i).toLocaleString("th-TH", { month: "short" }),
        })),
        { key: "year_total", label: "รวมรายปี" },
      ],
      items: [],
      form: {
        sale_id: null,
        start_date: new Date(moment().startOf("month").format("YYYY-MM-DD")),
        end_date: new Date(moment().endOf("month").format("YYYY-MM-DD")),
      },
      seller_list: [],
      sum: 0,
      selectedYear: new Date().getFullYear().toString(),
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  methods: {
    addThaiFont(doc) {
      if (!doc || !TH_SARABUN_TTF_BASE64) return;
      doc.addFileToVFS("THSarabun.ttf", TH_SARABUN_TTF_BASE64);
      doc.addFont("THSarabun.ttf", "THSarabun", "normal");
      doc.addFont("THSarabun.ttf", "THSarabun", "bold");
    },
    async onInitData() {
      try {
        const item = this.items;
        this.items = [];
        this.busy = true;
        this.apiStatus = "กำลังค้นหาข้อมูล..";

        const res = await this.$axios.get(
          this.$host +
            "/api/v1/report/customerbyyear?sale_id=" +
            (this.form.sale_id ? this.form.sale_id : "") +
            "&year=" +
            moment(this.selectedYear).format("YYYY")
        );

        const data = res.data;

        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.items = data.data;
        this.sum = data.grand_total;
      } catch (error) {
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async onLoadEmployee() {
      try {
        this.loading = true;
        const res = await this.$axios.get(
          this.$host + "/api/v1/document/quotation/branch/employee"
        );

        const newObj = { name: "--- ทั้งหมด ---", id: null };
        this.seller_list = res.data;

        this.seller_list.unshift(newObj);

        this.loading = false;
      } catch (error) {
        this.loading = false;

        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    exportPDFReport() {
      this.loading = true;
      setTimeout(async () => {
        this.loading = true;

        const result = await this.$axios.get(
          this.$host +
            "/api/v1/report/pdf/customerbyyear?sale_id=" +
            (this.form.sale_id ? this.form.sale_id : "") +
            "&keyword_startdate=" +
            moment(this.form.start_date).format("YYYY-MM-DD") +
            "&keyword_enddate=" +
            moment(this.form.end_date).format("YYYY-MM-DD"),

          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            responseType: "blob",
          }
        );
        const blob = new Blob([result.data], { type: "application/pdf" });
        const objectUrl = URL.createObjectURL(blob);
        var isSafari = /^((?!chrome|android).)*safari/i.test(
          navigator.userAgent
        );
        if (isSafari) {
          window.open(objectUrl);
          // const link = document.createElement('a')
          // link.href = objectUrl2
          // link.setAttribute('download', 'ใบเสนอราคา ' +  + '.pdf')
          // document.body.appendChild(link)
          // link.click()

          this.loading = false;
        } else {
          window.open(
            objectUrl,
            "targetWindow",
            `toolbar=no,
           location=no,
           status=no,
           menubar=no,
           scrollbars=yes,
           resizable=yes,
           width=SomeSize,
           height=SomeSize`
          );
          this.loading = false;
        }
        // URL.revokeObjectURL(objectUrl);
      }, 1000);
    },
    async exportExcelReport() {
      try {
        this.loading = true;

        const response = await this.$axios.get(
          this.$host +
            "/api/v1/report/excel/customerbyyear?sale_id=" +
            (this.form.sale_id ? this.form.sale_id : "") +
            "&keyword_startdate=" +
            moment(this.form.start_date).format("YYYY-MM-DD") +
            "&keyword_enddate=" +
            moment(this.form.end_date).format("YYYY-MM-DD"),
          { responseType: "blob" }
        );

        const url = URL.createObjectURL(
          new Blob([response.data], { type: "application/vnd.ms-excel" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Customer report.xls`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Cleanup after click
      } catch (error) {
        this.onExceptionHandler(
          error?.response?.data?.message ||
            "An error occurred while downloading the file."
        );
      } finally {
        this.loading = false;
      }
    },
    exportCustomerYearPdfFrontend() {
      if (!this.items || this.items.length === 0) {
        this.onExceptionHandler("ไม่มีข้อมูลให้ส่งออก");
        return;
      }

      const doc = new jsPDF("l", "mm", "a4"); // landscape
      this.addThaiFont?.(doc);
      doc.setFont("THSarabun", "normal");
      const title = `รายงานยอดขายตามลูกค้า รายปี ${this.selectedYear}`;
      doc.setFontSize(16);
      doc.text(title, 14, 15);

      // ตั้ง column header
      const months = Array.from({ length: 12 }, (_, i) =>
        new Date(0, i).toLocaleString("th-TH", { month: "short" })
      );

      const columns = [
        { header: "พนักงานขาย", dataKey: "seller" },
        { header: "ลูกค้า", dataKey: "customer" },
        ...months.map((m, i) => ({
          header: m,
          dataKey: `month_${i + 1}`,
        })),
        { header: "รวมปี", dataKey: "year_total" },
      ];

      // flatten data = seller + customer rows
      const rows = [];

      this.items.forEach((seller) => {
        seller.customers.forEach((c) => {
          const row = {
            seller: seller.bill_seller_name,
            customer: c.customer_name,
            year_total: parseFloat(c.year_total).toLocaleString(),
          };

          for (let m = 1; m <= 12; m++) {
            row[`month_${m}`] = parseFloat(c[`month_${m}`]).toLocaleString();
          }

          rows.push(row);
        });
      });

      autoTable(doc, {
        startY: 22,
        headStyles: {
          fillColor: [220, 220, 220],
          font: "THSarabun", // 👈 ใช้ฟอนต์ไทยในหัวตาราง
          fontStyle: "bold",
        },
        styles: {
          font: "THSarabun", // 👈 ตัวข้อความใช้ฟอนต์ไทย
          fontSize: 8,
        },
        head: [columns.map((col) => col.header)],
        body: rows.map((row) => columns.map((col) => row[col.dataKey])),
        margin: { top: 20 },
      });

      doc.save(`customer_by_year_${this.selectedYear}.pdf`);
    },
    exportCustomerYearExcelFrontend() {
      if (!this.items || this.items.length === 0) {
        this.onExceptionHandler("ไม่มีข้อมูลให้ส่งออก");
        return;
      }

      // header แถวแรก
      const months = Array.from({ length: 12 }, (_, i) =>
        new Date(0, i).toLocaleString("th-TH", { month: "short" })
      );

      const header = [
        "พนักงานขาย",
        "ลูกค้า",
        ...months, // เดือน 1–12
        "รวมปี",
      ];

      // flatten data เหมือน PDF
      const dataRows = [];

      this.items.forEach((seller) => {
        seller.customers.forEach((c) => {
          const row = [];

          row.push(seller.bill_seller_name); // พนักงานขาย
          row.push(c.customer_name); // ลูกค้า

          for (let m = 1; m <= 12; m++) {
            row.push(Number(c[`month_${m}`] || 0)); // เป็นตัวเลขดิบ ให้ Excel format เองได้
          }

          row.push(Number(c.year_total || 0));

          dataRows.push(row);
        });
      });

      // รวม header + data
      const wsData = [header, ...dataRows];

      // สร้าง worksheet / workbook
      const worksheet = XLSX.utils.aoa_to_sheet(wsData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "รายงาน");

      // สั่งให้ browser ดาวน์โหลดไฟล์
      XLSX.writeFile(workbook, `customer_by_year_${this.selectedYear}.xlsx`);
    },
  },
  async mounted() {
    await this.onLoadEmployee();
  },
};
